import React from "react";
import { PACK_REPLACEMENT_DISPLAY, getPackReplacementGlyphUrl } from "./packReplacementAnnotations";

// Hover / pinned card for a pack replacement marker. Serialized to static HTML by
// setupAnnotationTooltips, so it uses inline styles only (mirrors AnnotationTooltip).
const chipStyle = {
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    background: "#F0F0F0",
    color: "#000000",
    padding: "0 12px",
    borderRadius: "4px",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "24px",
};

const labelStyle = { color: "#8F8F8F" };

const serialStyle = { fontWeight: 500, fontSize: "12px", lineHeight: "18px", color: "#000000", wordBreak: "break-all" };

const PackCard = ({ pack, isLast }) => (
    <div
        style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            minWidth: "380px",
            backgroundColor: "#FAFAFA",
            padding: "12px 16px",
            borderRadius: "8px",
            marginBottom: isLast ? "0" : "12px",
        }}
    >
        <div style={{ display: "flex", flexDirection: "column" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
                <span style={{ fontSize: "14px", lineHeight: "18px", fontWeight: 500, color: "#000000" }}>
                    {[pack.string, pack.pack].filter(Boolean).join(" · ") || "Pack"}
                </span>
                <span
                    style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "4px",
                        background: PACK_REPLACEMENT_DISPLAY.bg,
                        color: PACK_REPLACEMENT_DISPLAY.color,
                        padding: "2px 8px",
                        borderRadius: "500px",
                        fontWeight: 600,
                        fontSize: "11px",
                        lineHeight: "16px",
                        whiteSpace: "nowrap",
                    }}
                >
                    <img src={getPackReplacementGlyphUrl()} width="14" height="14" alt="" style={{ flexShrink: 0 }} />
                    {PACK_REPLACEMENT_DISPLAY.label}
                </span>
            </div>
            <div style={{ fontWeight: 500, fontSize: "12px", lineHeight: "20px", color: "#494949" }}>
                {pack.recordedAt}
            </div>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr auto 1fr", gap: "8px", alignItems: "center" }}>
            <div>
                <div style={{ ...labelStyle, fontSize: "11px", lineHeight: "16px" }}>Outgoing</div>
                <div style={serialStyle}>{pack.outgoingSerial || "-"}</div>
            </div>
            <span style={{ color: "#8F8F8F" }}>&rarr;</span>
            <div>
                <div style={{ ...labelStyle, fontSize: "11px", lineHeight: "16px" }}>Incoming</div>
                <div style={serialStyle}>{pack.incomingSerial || "-"}</div>
            </div>
        </div>

        <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
            {pack.odometerKm !== null && pack.odometerKm !== undefined && !isNaN(parseFloat(pack.odometerKm)) && (
                <span style={chipStyle}>
                    <span style={labelStyle}>Odometer</span>
                    {`${Math.round(parseFloat(pack.odometerKm)).toLocaleString("en-IN")} km`}
                </span>
            )}
            {pack.reasons.length > 0 && (
                <span style={chipStyle}>
                    <span style={labelStyle}>Reason</span>
                    {pack.reasons.join(", ")}
                </span>
            )}
            {pack.recordedByName && (
                <span style={chipStyle}>
                    <span style={labelStyle}>By</span>
                    {pack.recordedByName}
                </span>
            )}
        </div>
    </div>
);

const PackReplacementTooltip = ({ timePoint }) => {
    const packs = timePoint?.packs || [];
    return (
        <div
            style={{
                backgroundColor: "#FFFFFF",
                borderRadius: "8px",
                padding: "12px",
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
                minWidth: "200px",
                fontFamily: "Roboto, sans-serif",
            }}
        >
            <div style={{ fontSize: "16px", fontWeight: 700, lineHeight: "20px", color: "#000000", marginBottom: "12px" }}>
                {PACK_REPLACEMENT_DISPLAY.label}
                {packs.length > 1 ? ` (${packs.length})` : ""}
            </div>
            {packs.map((pack, index) => (
                <PackCard key={`${pack.requestID}-${index}`} pack={pack} isLast={index === packs.length - 1} />
            ))}
        </div>
    );
};

export default PackReplacementTooltip;
